import React, {ReactNode} from 'react';
import '../../../designTokens/assets/sass/components/main.scss';
import { Container } from 'react-bootstrap';
import { GlobalStyle } from 'shared/global-styles';
import { Banner, BannerProps } from 'molecules/Banner';

export interface AppPageProps {
    NavBarElement: ReactNode;
    showBanner: boolean;
    banner: BannerProps;
    children?: React.ReactNode;
}

export function AppPage({NavBarElement, ...props}: AppPageProps) {

  return (
    <>
        {NavBarElement}
        {props.showBanner && (
            <>
                <div style={{ position: "fixed", width: "100%", display: "flex", flexDirection: "row-reverse", zIndex: "100" }}>
                    <Banner
                        {...props.banner}
                    />
                </div>
            </>
        )}
        <div style={{ marginTop: "40px" }}>
            {props.children}
        </div>
        <GlobalStyle />
    </>
  );
}
